import { getTreatmentNameWithDuration } from 'src/utils/getTreatmentNameWithDuration'
import { useGetTreatmentDuration } from './useGetTreatmentDuration'
import { useGetTreatmentInfo } from './useGetTreatmentInfo'
import { useGetTreatmentName } from './useGetTreatmentName'

export const useGetTreatmentTitleWithDuration = () => {
  const treatmentInfo = useGetTreatmentInfo()
  const treatmentName = useGetTreatmentName()

  const treatmentDuration = useGetTreatmentDuration({
    minDuration: treatmentInfo.treatment?.minDurationInMin,
    maxDuration: treatmentInfo.treatment?.maxDurationInMin,
  })

  const treatmentTitle = getTreatmentNameWithDuration(treatmentName, treatmentDuration)

  return treatmentTitle
}
